import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { AttachmentImage, UserId, Uuid } from '../Base';
import { RepositoryElement } from '../Repository';

interface LeaderboardParticipants {
  [leaderboardId: string]: number;
}

export interface SpaceTeamJson<T = number> {
  readonly teamId: Uuid; //identifier
  classroomId: Uuid;
  createdBy: UserId;
  createdAt: T;
  lastModifiedAt: T;
  isSuspended?: boolean;
  name: string;
  description: null | string;
  icon: AttachmentImage;
  leaderboardParticipants: LeaderboardParticipants;
}

export class SpaceTeam
  extends RepositoryElement
  implements SpaceTeamJson<Date>
{
  teamId!: Uuid;
  classroomId!: Uuid;
  createdBy!: UserId;
  createdAt!: Date;
  lastModifiedAt!: Date;
  isSuspended?: boolean;
  name!: string;
  description!: null | string;
  icon!: AttachmentImage;
  leaderboardParticipants!: LeaderboardParticipants;

  constructor(spaceTeam: SpaceTeamJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(spaceTeam));
  }

  id() {
    return this.teamId;
  }

  toJSON(): SpaceTeamJson {
    return deepTransformDate(this) as unknown as SpaceTeamJson;
  }
}
